<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@wielink-application/shared/js/mixins/formInput";
import Textarea from "@/pages/components/form/input-only/textarea.vue";

export default {
  mixins: [formInput],
  components: {FormGroup, Textarea},
  props: {
    'groupClasses' : {
      type: String,
      required: false
    },
    'label': {
      type: String,
      required: false
    }
  }
}
</script>

<template>
  <FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
    <template #label>{{ label }}</template>

    <Textarea
      v-bind="$attrs"
      :form="form"
      :name="name"
      :id="renderedId"
      :model-value="modelValue"
      @update:modelValue="changeModelValueTo"
    />
  </FormGroup>
</template>